import {Api} from "../config/request";

const getPasswordPolicy = async (data) => {
    let response = await Api.PostRequest("/getPasswordPolicy", data);
    return response.data;
}

const passwordApi = {
    getPasswordPolicy,
}
export default passwordApi;